import { Select } from "antd";
import { useProjectParticipants } from "hooks/project-participants";
import { useState, useEffect } from "react";

const { Option } = Select;

function ResponsibleDesignFirmsDropdown(props: any) {
  const { value, onChange, disabled, defaultOpen = false } = props;
  const { projectParticipants } = useProjectParticipants();
  const dataLoaded = projectParticipants?.dataLoaded;
  // Show all project companies, not just Architect/Engineer firms.
  const designFirms = projectParticipants?.materialTradePartners;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (defaultOpen && dataLoaded) {
      setOpen(true);
    }
  }, [defaultOpen, dataLoaded]);

  return (
    <Select
      className="w-full"
      value={value || undefined}
      allowClear
      onChange={onChange}
      showSearch
      loading={!dataLoaded}
      filterOption={(inputValue, option: any) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
      disabled={disabled}
      data-testid="index-select-responsible-design-firm"
      {...(defaultOpen && { open, onOpenChange: setOpen })}
    >
      {(designFirms ?? []).map((cmpny: any) => {
        return (
          <Option
            key={cmpny.vendor_id}
            value={cmpny.vendor_id}
            label={`${cmpny?.subscription_vendor?.name}`}
          >
            <div className="text-[14px] text-ciq-gray-950">
              {cmpny?.subscription_vendor?.name}
            </div>
          </Option>
        );
      })}
    </Select>
  );
}

export default ResponsibleDesignFirmsDropdown;
